import FeaturesService from "@/services/v2/common/features.service";
export const featuresApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    exportExcel({ commit }, jsonData) {
      return FeaturesService.exportExcel(jsonData).then(
        (resp) => {
          commit("dummyConsole", "FeaturesService.exportExcel - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "FeaturesService.exportExcel - error");
          return Promise.reject(error);
        }
      );
    },
    generateNachaFile({ commit }, nachaEntryModel) {
      return FeaturesService.generateNachaFile(nachaEntryModel).then(
        (resp) => {
          commit("dummyConsole", "FeaturesService.generateNachaFile - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "FeaturesService.generateNachaFile - error");
          return Promise.reject(error);
        }
      );
    },
    encrypt({ commit }, val) {
      return FeaturesService.encrypt(val).then(
        (resp) => {
          commit("dummyConsole", "FeaturesService.encrypt - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "FeaturesService.encrypt - error");
          return Promise.reject(error);
        }
      );
    },

    decrypt({ commit }, val) {
      return FeaturesService.decrypt(val).then(
        (resp) => {
          commit("dummyConsole", "FeaturesService.decrypt - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "FeaturesService.decrypt - error");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
